import React from "react";
import ConnectedGiftAssist from "../Pages/PaymentPage/ConnectedGiftAssist";

const GiftAssistControl = () => (
    <div className="grid">
        <ConnectedGiftAssist />
    </div>
);

export default GiftAssistControl;
